<template>
  <div >
    <div class="relative h-70 overflow-hidden shadow " v-if="foods.products">
      <img :src="foods.imgUrl" alt="" class=" w-full" />
      <div
        class="absolute bg-gray-500/50 w-full h-full flex items-center justify-center top-0"
      >
        <span class="text-gray-200 text-2xl font-bold">{{
          foods.menu_Name
        }}</span>
      </div>
    </div>
    <div>
      <div
        class="flex flex-row text-gray-700 items-center justify-center pt-4"
        v-if="!foods.products"
      >
        <img src="../assets/img/logo.png" class="w-10 h-10" />
        <span class="mr-2 font-bold text-sm">رستوران تخت جمشید شاندیز</span>
      </div>
      <div class="grid grid-cols-2 p-2 pt-4">
        <CategoryCard
          v-for="category in categories"
          :key="category.id"
          :category="category"
        />
      </div>
      <div class="grid grid-cols-1 p-2 pt-4 mb-28">
        <MenuFoodCard
          v-for="food in foods.products"
          :key="food.id"
          :food="food"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getHomeCategory, getSubMenu } from "@/API/API";
import CategoryCard from "@/components/CategoryCard";
import MenuFoodCard from "@/components/MenuFoodCard";
//import VButton from "@/components/General/VButton";

export default {
  name: "MenuPage",
  components: { CategoryCard, MenuFoodCard },
  data() {
    return {
      categories: [],
      foods: {},
      //fullScreenImage: "",
    };
  },
  async created() {
    if (this.$route.query.type) {
      this.categories = (await getHomeCategory(1)).data.result;
    } else if (this.$route.params.id) {
      this.foods = (await getSubMenu(this.$route.params.id)).data.result;
    } else {
      this.categories = (await getHomeCategory()).data.result;
    }
    console.log(this.categories);
    console.log(this.foods);
  },
  watch: {
    async $route() {
      if (this.$route.params.id) {
        this.categories = [];
        this.foods = (await getSubMenu(this.$route.params.id)).data.result;
      } else {
        this.foods = [];
        this.categories = (await getHomeCategory()).data.result;
      }
    },
  },
};
</script>
